// Sentry error tracking — only initializes if REACT_APP_SENTRY_DSN is set
// Set the DSN in /app/frontend/.env after creating a project at sentry.io
import * as Sentry from '@sentry/react';

export function initSentry() {
  const dsn = process.env.REACT_APP_SENTRY_DSN;
  if (!dsn) {
    // Silently no-op when DSN is not configured (dev, preview, tests)
    return;
  }

  Sentry.init({
    dsn,
    environment: process.env.REACT_APP_SENTRY_ENV || 'production',
    // Tracing — Web Vitals + route perf
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // Sample rates
    tracesSampleRate: 0.15,             // 15% of transactions get performance traces
    replaysSessionSampleRate: 0.05,     // 5% of normal sessions get replay
    replaysOnErrorSampleRate: 1.0,      // 100% of error sessions get replay
    // Ignore noisy browser errors that aren't actionable
    ignoreErrors: [
      'Non-Error promise rejection captured',
      'ResizeObserver loop limit exceeded',
      'ResizeObserver loop completed with undelivered notifications',
      /Failed to fetch dynamically imported module/,
      /Loading chunk .* failed/,
      /Loading CSS chunk .* failed/,
    ],
    // Filter out browser extensions and third-party noise
    denyUrls: [
      /extensions\//i,
      /^chrome:\/\//i,
      /^moz-extension:\/\//i,
    ],
  });
}

export const SentryErrorBoundary = Sentry.ErrorBoundary;
